import gql from 'graphql-tag';

export const updateEmailGroup = gql`
  mutation updateEmailGroup($id: String!, $changes: EmailGroupInput) {
    updateEmailGroup(id: $id, changes: $changes) {
      id
      name
      enabled
      updater
      createdAt
      updatedAt
      deletedAt
      version
      EmailGroupMembers {
        id
        address
        version
      }
      businessUnits {
        name
        id
      }
    }
  }
`;
